import { SHARE_MESSAGE, REVOKE_MESSAGE_SHARE, LEAVE_SHARED_MESSAGE, PUBLISH_MESSAGE, UNPUBLISH_MESSAGE } from './sharing/message-sharing';
import { SET_FOLDER_REFERENCE, SET_FOLDER_REFERENCE_FAVORITE, JOIN_PUBLISHED_FOLDER, ADD_PUBLISHED_MESSAGE } from './sharing/folder-links';
import { CREATE_FOLDER } from './folder/create-folder';
import { CLEAR_FOLDER_LAST_VIEWED } from './folder/clear-folder-last-viewed';
import { DELETE_FOLDERS } from './folder/delete-folders';
import { MOVE_FOLDER } from './folder/move-folder';
import { PLACE_FOLDER } from './folder/place-folder';
import { PLACE_PINNED_FOLDER } from './folder/place-pinned-folder';
import { REODER_FOLDERS } from './folder/reorder-folders';
import { RESTORE_FOLDER } from './folder/restore-folder';
import { SET_FOLDER_PINNED } from './folder/set-folder-pinned';
import { SET_FOLDER_MANUAL_MESSAGE_SORT } from './folder/set-folder-manual-message-sort';
import { TRASH_FOLDERS } from './folder/trash-folders';
import { UPDATE_FOLDER } from './folder/update-folder';

import { RESTORE_MESSAGES } from './message/restore-messages';
import { TRASH_MESSAGES } from './message/trash-messages';
import { UNSTAR_MESSAGE } from './message/unstar-message';
import { STAR_MESSAGE } from './message/star-message';
import { CHECK_MESSAGE } from './message/check-message';
import { UNCHECK_MESSAGE } from './message/uncheck-message';
import { REMOVE_CHECKBOX } from './message/remove-checkbox';
import { RESTORE_MESSAGE_REVISION } from './message/restore-message-revision';
import { SET_MESSAGE_REMINDER } from './message/set-message-reminder';
import { CLEAR_MESSAGE_REMINDER } from './message/clear-message-reminder';
import { SET_MESSAGE_DUE } from './message/set-message-due';
import { CLEAR_MESSAGE_DUE } from './message/clear-message-due';
import { ATTACH_MESSAGES_TO_THREAD } from './message/attach-messages-to-thread';
import { ADD_CHECKBOX } from './message/add-checkbox';
import { UPDATE_MESSAGE } from './message/update-message';
import { UPDATE_ARTIFACT_USER_STATE } from './message/update-artifact-user-state';
import { DELETE_MESSAGES } from './message/delete-messages';
import { MOVE_MESSAGES } from './message/move-messages';
import { PLACE_MESSAGE } from './message/place-message';
import { CREATE_MESSAGE } from './message/create-message';
import { CREATE_MESSAGE_FROM_AUDIO } from './message/create-message-from-audio';
import { REFRESH_BOOKMARK_PREVIEW } from './message/refresh-bookmark-preview';
import { S3_SIGN } from './message/sign-s3';
import { INITIATE_MULTIPART_UPLOAD, COMPLETE_MULTIPART_UPLOAD, ABORT_MULTIPART_UPLOAD } from './message/multipart-upload';
import { SUBMIT_SEARCH_FILTER_SUGGESTION } from './message/submit-search-filter-suggestion';
import { SUBMIT_AI_CHAT_MESSAGE_FEEDBACK } from './message/submit-ai-chat-message-feedback';

import { DELETE_USER } from './user/delete-user';
import { DELETE_USER_ADMIN } from './user/delete-user-admin';
import { DUPLICATE_ACCOUNT } from './user/duplicate-account';
import { UPDATE_STORAGE } from './user/update-storage';
import { VERIFY_ACCOUNT } from './user/verify-account';
import { SEND_VERIFICATION_EMAIL } from './user/send-verification-email';
import {SUBMIT_DISCOVERY_SOURCE} from './user/submit-discovery-source';
import { UPDATE_USER_DETAILS } from './user/update-user-details';
import { EXTRACT_CAROUSEL_OCR } from './message/extract-carousel-ocr';
import { EXTRACT_CAROUSEL_ARTIFACTS } from './message/extract-carousel-artifacts';
import { RESET_PASSWORD_MANUAL } from './user/reset-password-manual';
import { RESET_PASSWORD_MAIL } from './user/reset-password-mail';
import { REGISTER } from './user/register';
import { LOGIN } from './user/login';
import { CREATE_EXTENSION_AUTH_CODE } from './user/create-extension-auth-code';
import { LOCK_ACCOUNT_MANUAL } from './user/lock-account-manual';
import { FORGOT_PASSWORD_SEND_EMAIL } from './user/forgot-password-send-email';
import { DELETE_ACCOUNT } from './user/delete-account';
import { REQUEST_DATA_EXPORT } from './user/request-data-export';
import { CANCEL_MY_DATA_EXPORT } from './user/cancel-my-data-export';
import { DECLINE_ADMIN_DATA_EXPORT } from './user/decline-admin-data-export';
import { REDO_ADMIN_DATA_EXPORT } from './user/redo-admin-data-export';
import { RESEND_ADMIN_DATA_EXPORT_EMAIL } from './user/resend-admin-data-export-email';
import { REQUEST_MESSAGES_EXPORT } from './user/request-messages-export';
import { CHANGE_MESSAGE_QUOTA } from './user/change-message-quota';
import { CHANGE_USER_PLAN } from './user/change-user-plan';
import { GENERATE_REFERRAL_LINK } from './user/generate-referral-link';
import { SEND_EMAIL_CAMPAIGN } from './user/send-email-campaign';
import { SEND_EMAIL_CAMPAIGN_TEST } from './user/send-email-campaign-test';
import { ENROLL_ACTIVATION_EMAIL_SEQUENCE } from './user/enroll-activation-email-sequence';
import { SEND_TRIAL_EXPIRY_REMINDER_MANUAL } from './user/send-trial-expiry-reminder-manual';
import { SEND_PUSH_CAMPAIGN } from './user/send-push-campaign';
import { SEND_PUSH_CAMPAIGN_TEST } from './user/send-push-campaign-test';
import { UPDATE_MARKETING_EMAIL_PREFERENCE } from './user/update-marketing-email-preference';
import { UPDATE_USER_STORAGE } from './user/update-user-storage';
import { UPDATE_USER_FILE_SIZE } from './user/update-user-file-size';
import { UPDATE_USER_MAX_CREDITS } from './user/update-user-max-credits';
import { TEST_RESEND_EMAIL } from './user/test-resend-email';
import { TRIGGER_AI_ORGANIZATION_BACKFILL } from './user/trigger-ai-organization-backfill';
import { ADD_CREDITS } from './user/add-credits';
import { CREATE_API_TOKEN } from './user/create-api-token';
import { REVOKE_API_TOKEN } from './user/revoke-api-token';
import {
    CREATE_ANNOUNCEMENT_BANNER,
    UPDATE_ANNOUNCEMENT_BANNER,
    DELETE_ANNOUNCEMENT_BANNER
} from '../announcementBanners';

import { SHARE_FOLDER } from './sharing/share-folder';
import { UPDATE_FOLDER_SHARE_ROLE } from './sharing/update-folder-share-role';
import { LEAVE_SHARED_FOLDER } from './sharing/leave-shared-folder';
import { REVOKE_FOLDER_SHARE } from './sharing/revoke-folder-share';
import { PUBLISH_FOLDER } from './sharing/publish-folder';
import { UNPUBLISH_FOLDER } from './sharing/unpublish-folder';
import { COPY_PUBLISHED_FOLDER } from './sharing/copy-published-folder';
import { COPY_SHARED_MESSAGE } from './sharing/copy-shared-message';

import { CREATE_CHECKOUT_SESSION } from './purchase/create-checkout-session'
import { CANCEL_SUBSCRIPTION } from './purchase/cancel-subscription'
import { CREATE_PAYMENT_INTENT } from './purchase/create-payment-intent'

import { RESTART_TELEGRAM_BOT } from './telegram/restart-telegram-bot';
import { SEND_MESSAGE_TO_TELEGRAM } from './telegram/send-message-to-telegram';
import { UNLINK_SLACK_ACCOUNT } from './slack/unlink-slack';
import { UPDATE_SLACK_INTEGRATION } from './slack/update-slack-integration';
import { SEND_MESSAGE_TO_SLACK } from './slack/send-message-to-slack';
import { AI_CHAT_COMPLETION } from './ai/ai-chat-completion';
import { PREPARE_CHAT_ACTION } from './ai/prepare-chat-action';
import { CREATE_CHAT_ACTION } from './ai/create-chat-action';
import { UPDATE_CHAT_ACTION } from './ai/update-chat-action';
import { DELETE_CHAT_ACTION } from './ai/delete-chat-action';
import { UPDATE_PLAN } from './plan/update-plan';
import { TRANSCRIBE_AUDIO } from './message/transcribe-audio';
import { TEXT_TO_SPEECH } from './message/text-to-speech';
import { PREVIEW_TEXT_TO_SPEECH } from './message/preview-text-to-speech';
import { SET_OPENAI_KEY } from './user/set-openai-key';
import { REMOVE_OPENAI_KEY } from './user/remove-openai-key';
import { VALIDATE_OPENAI_KEY } from './user/validate-openai-key';
import { SET_GROQ_KEY } from './user/set-groq-key';
import { REMOVE_GROQ_KEY } from './user/remove-groq-key';
import { VALIDATE_GROQ_KEY } from './user/validate-groq-key';
import { RETRY_ADMIN_AUDIO_TRANSCRIPTION_JOBS } from './user/retry-admin-audio-transcription-jobs';
import { TEST_MEDIA_EXTRACTION_ADMIN } from './user/test-media-extraction-admin';
import { RERUN_ADMIN_VIDEO_FRAME_ANALYSIS_JOBS } from './user/rerun-admin-video-frame-analysis-jobs';
import { CREATE_ADMIN_VIDEO_FRAME_ANALYSIS_DIAGNOSTIC_EXPORT } from './user/create-admin-video-frame-analysis-diagnostic-export';
import { CREATE_ADMIN_ARTIFACT_DIAGNOSTIC_EXPORT } from './user/create-admin-artifact-diagnostic-export';
import { RESYNC_ADMIN_ARTIFACT_DIAGNOSTIC } from './user/resync-admin-artifact-diagnostic';
import { SET_DAILY_REVIEW_ENABLED } from './user/set-daily-review-enabled';
import { SET_MESSAGE_GROUPING_ENABLED } from './user/set-message-grouping-enabled';
import { DISMISS_DAILY_REVIEW_SUGGESTION } from './user/dismiss-daily-review-suggestion';
import { SUBMIT_DAILY_REVIEW_FEEDBACK } from './user/submit-daily-review-feedback';
import { DEBUG_REGENERATE_DAILY_REVIEW } from './user/debug-regenerate-daily-review';

const MUTATION = {
    SHARE_MESSAGE, REVOKE_MESSAGE_SHARE, LEAVE_SHARED_MESSAGE, PUBLISH_MESSAGE, UNPUBLISH_MESSAGE,
    CREATE_FOLDER,
    CLEAR_FOLDER_LAST_VIEWED,
    DELETE_FOLDERS,
    MOVE_FOLDER,
    PLACE_FOLDER,
    PLACE_PINNED_FOLDER,
    REODER_FOLDERS,
    RESTORE_FOLDER,
    SET_FOLDER_PINNED,
    SET_FOLDER_MANUAL_MESSAGE_SORT,
    TRASH_FOLDERS,
    UPDATE_FOLDER,
    RESTORE_MESSAGES,
    TRASH_MESSAGES,
    UNSTAR_MESSAGE,
    STAR_MESSAGE,
    CHECK_MESSAGE,
    UNCHECK_MESSAGE,
    REMOVE_CHECKBOX,
    RESTORE_MESSAGE_REVISION,
    SET_MESSAGE_REMINDER,
    CLEAR_MESSAGE_REMINDER,
    SET_MESSAGE_DUE,
    CLEAR_MESSAGE_DUE,
    ATTACH_MESSAGES_TO_THREAD,
    ADD_CHECKBOX,
    UPDATE_MESSAGE,
    UPDATE_ARTIFACT_USER_STATE,
    DELETE_MESSAGES,
    MOVE_MESSAGES,
    PLACE_MESSAGE,
    CREATE_MESSAGE,
    CREATE_MESSAGE_FROM_AUDIO,
    REFRESH_BOOKMARK_PREVIEW,
    S3_SIGN,
    INITIATE_MULTIPART_UPLOAD,
    COMPLETE_MULTIPART_UPLOAD,
    ABORT_MULTIPART_UPLOAD,
    SUBMIT_SEARCH_FILTER_SUGGESTION,
    SUBMIT_AI_CHAT_MESSAGE_FEEDBACK,
    UPDATE_STORAGE,
    VERIFY_ACCOUNT,
    SEND_VERIFICATION_EMAIL,
    UPDATE_USER_DETAILS,
    SUBMIT_DISCOVERY_SOURCE,
    EXTRACT_CAROUSEL_OCR,
    EXTRACT_CAROUSEL_ARTIFACTS,
    RESET_PASSWORD_MANUAL,
    RESET_PASSWORD_MAIL,
    REGISTER,
    LOGIN,
    CREATE_EXTENSION_AUTH_CODE,
    LOCK_ACCOUNT_MANUAL,
    FORGOT_PASSWORD_SEND_EMAIL,
    DELETE_ACCOUNT,
    CHANGE_MESSAGE_QUOTA,
    CHANGE_USER_PLAN,
    DELETE_USER,
    DELETE_USER_ADMIN,
    DUPLICATE_ACCOUNT,
    GENERATE_REFERRAL_LINK,
    SEND_EMAIL_CAMPAIGN,
    SEND_EMAIL_CAMPAIGN_TEST,
    ENROLL_ACTIVATION_EMAIL_SEQUENCE,
    SEND_TRIAL_EXPIRY_REMINDER_MANUAL,
    SEND_PUSH_CAMPAIGN,
    SEND_PUSH_CAMPAIGN_TEST,
    UPDATE_MARKETING_EMAIL_PREFERENCE,
    UPDATE_USER_STORAGE,
    UPDATE_USER_FILE_SIZE,
    UPDATE_USER_MAX_CREDITS,
    TEST_RESEND_EMAIL,
    ADD_CREDITS,
    TRIGGER_AI_ORGANIZATION_BACKFILL,
    CREATE_CHECKOUT_SESSION,
    CANCEL_SUBSCRIPTION,
    CREATE_PAYMENT_INTENT,
    RESTART_TELEGRAM_BOT,
    SEND_MESSAGE_TO_TELEGRAM,
    UNLINK_SLACK_ACCOUNT,
    UPDATE_SLACK_INTEGRATION,
    SEND_MESSAGE_TO_SLACK,
    UPDATE_PLAN,
    AI_CHAT_COMPLETION,
    PREPARE_CHAT_ACTION,
    CREATE_CHAT_ACTION,
    UPDATE_CHAT_ACTION,
    DELETE_CHAT_ACTION,
    TRANSCRIBE_AUDIO,
    TEXT_TO_SPEECH,
    PREVIEW_TEXT_TO_SPEECH,
    SET_OPENAI_KEY,
    REMOVE_OPENAI_KEY,
    VALIDATE_OPENAI_KEY,
    SET_GROQ_KEY,
    REMOVE_GROQ_KEY,
    VALIDATE_GROQ_KEY,
    RETRY_ADMIN_AUDIO_TRANSCRIPTION_JOBS,
    TEST_MEDIA_EXTRACTION_ADMIN,
    RERUN_ADMIN_VIDEO_FRAME_ANALYSIS_JOBS,
    CREATE_ADMIN_VIDEO_FRAME_ANALYSIS_DIAGNOSTIC_EXPORT,
    CREATE_ADMIN_ARTIFACT_DIAGNOSTIC_EXPORT,
    RESYNC_ADMIN_ARTIFACT_DIAGNOSTIC,
    SET_DAILY_REVIEW_ENABLED,
    SET_MESSAGE_GROUPING_ENABLED,
    DISMISS_DAILY_REVIEW_SUGGESTION,
    SUBMIT_DAILY_REVIEW_FEEDBACK,
    DEBUG_REGENERATE_DAILY_REVIEW,
    REQUEST_DATA_EXPORT,
    CANCEL_MY_DATA_EXPORT,
    DECLINE_ADMIN_DATA_EXPORT,
    REDO_ADMIN_DATA_EXPORT,
    RESEND_ADMIN_DATA_EXPORT_EMAIL,
    REQUEST_MESSAGES_EXPORT,
    CREATE_API_TOKEN,
    REVOKE_API_TOKEN,
    SET_FOLDER_REFERENCE, SET_FOLDER_REFERENCE_FAVORITE, JOIN_PUBLISHED_FOLDER, ADD_PUBLISHED_MESSAGE,
    SHARE_FOLDER,
    UPDATE_FOLDER_SHARE_ROLE,
    REVOKE_FOLDER_SHARE,
    LEAVE_SHARED_FOLDER,
    PUBLISH_FOLDER,
    UNPUBLISH_FOLDER,
    COPY_PUBLISHED_FOLDER,
    COPY_SHARED_MESSAGE,
    CREATE_ANNOUNCEMENT_BANNER,
    UPDATE_ANNOUNCEMENT_BANNER,
    DELETE_ANNOUNCEMENT_BANNER
};

export default MUTATION;
